import React, { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Lookup } from 'src/common/Common.Type'

interface ITabSwitch {
    Tabs: Lookup[]
    setTab: Function
    defaultSelect: number
}

const TabSwitch: FC<ITabSwitch> = ({ Tabs, setTab, defaultSelect = 0 }) => {

    const { t } = useTranslation()
    const [activeTab, setActiveTab] = useState(defaultSelect)

    const handleSelect = (id: number) => {
        setActiveTab(id)
        setTab(id)
    }


    return (
        <div className="screen-tabs">
            {Tabs.map((item: Lookup) =>
                <div key={item.value} onClick={() => handleSelect(item.value)} className={`${activeTab == item.value ? 'selected' : ""} pointer current-tab`}>
                    <label className="pointer">{t(item.label)}</label>
                </div>
            )}
        </div>
    )
}

export default TabSwitch